module.exports = {"320302001":"黄楼街道","320302002":"丰财街道","320302003":"琵琶街道","320302004":"牌楼街道","320302005":"铜沛街道","320302006":"环城街道","320302007":"九里街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320302.json
// module id = 848
// module chunks = 0